import Vue from 'vue'
import VueRouter from 'vue-router'
import beforeEach from './beforeEach'
import login from '@/pages/login.vue'
import enrichment from '@/pages/enrichment.vue'
import index from '@/pages/index.vue'
import categoria from '@/pages/categoria.vue'
import video from '@/pages/video.vue'
import tyc from '@/pages/tyc.vue'
import cancelacion from '@/pages/cancelacion.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: index
  },
  {
    path: '/category/:id',
    name: 'category',
    component: categoria,
    props: true
  },
  {
    path: '/video/:categoriaId/:videoId',
    name: 'video',
    component: video,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cancelacion',
    name: 'cancelacion',
    component: cancelacion,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tyc',
    name: 'tyc',
    component: tyc
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/enrichment/login',
    name: 'login.enrichment',
    component: enrichment
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(beforeEach) // Comprueba permisos

export default router
